import { useEffect, useCallback } from 'react';

export default function usePageVisibilityChange(socket) {
  const visibilityChangeEventListener = useCallback(() => {
    if (!document.hidden && !socket.connected) {
      console.log('The socket is reconnecting due to page visibility change');
      socket.connect();
    }
  }, []);

  useEffect(() => {
    document.addEventListener(
      'visibilitychange',
      visibilityChangeEventListener,
    );
    return () => {
      window.removeEventListener(
        'visibilitychange',
        visibilityChangeEventListener,
      );
    };
  }, []);
}
